/** @format */
import { DateHelperTs } from '../../helpers/DateHelperTs';

export const systemAccessType = {
    OPL_ACCESS: 1 << 0,
    SAT_ACCESS: 1 << 1,

    //Custom access
    CUSTOM_ACCESS_1: 1 << 10,
    CUSTOM_ACCESS_2: 1 << 11,
    CUSTOM_ACCESS_3: 1 << 12,
    CUSTOM_ACCESS_4: 1 << 13,
    CUSTOM_ACCESS_5: 1 << 14,

    SYSTEM_ACCESS_IDENTIFIER: 'systemAccessData',
    ROLES_IDENTIFIER: 'systemRolesData',
    PASSWORD_DATA_IDENTIFIER: 'systemPasswordData',
    CERTIFICATION_DATA_IDENTIFIER: 'systemCertificationData',
};

export const tokenInfo = {
    PLATFORM_RESELLER_ID: 'platformResellerId',
    PLATFORM_RESELLER_NAME: 'platformResellerName',
    PLATFORM_USER_ID: 'userid',
    PLATFORM_USER_LOGIN: 'username',
    PLATFORM_USER_SESSION_EXPIRATION_TIME: 'session_expiration_time',
    PLATFORM_USER_SESSION_START_TIME: 'session_start_time',
    PLATFORM_USER_PLATFORM_TYPE: 'platformType',
    PLATFORM_USER_TYPE: 'userType',
    PLATFORM_USER_EXPERT_MODE: 'expert_mode',
    PLATFORM_USER_HAS_ACTIVE_SERIAL: 'userHasActiveSerial',
    PLATFORM_USER_IS_ROOT_RESELLER: 'userIsRootReseller',
    PLATFORM_USER_USED_KERBEROS: 'usedKerberos',
    PLATFORM_USER_CUSTOMER_LEVEL: 'platformUserCustomerLevel',

    PLATFORM_USER_CURRENCY_NAME: 'currencyName',
    PLATFORM_USER_CURRENCY_SHORT: 'currencyShort',
    PLATFORM_USER_CURRENCY_SIGN: 'currencySign',

    SYSTEM_TYPE_MVNO_ADMIN: 'mvno',
    SYSTEM_TYPE_MVNO_PARTNER: 'mvnoPartner',
    SYSTEM_TYPE_MVNO_PARTNER_EXPERT: 'mvnoPartnerExpert',
    SYSTEM_TYPE_MVNO_ADMIN_EXPERT: 'mvnoExpert',
    SYSTEM_TYPE_CRM: 'crm',

    STORE_BROWSER_CARD_ID: 'STORE_BROWSER_CARD_ID',
};

export const Auth = {
    isSameBrowser: (): boolean => {
        return !!window.sessionStorage.getItem(tokenInfo.STORE_BROWSER_CARD_ID);
    },

    getAccessToken: (): string => {
        return window.sessionStorage.getItem('token') ?? '';
    },

    storeToken: (token: string): void => {
        if (typeof token === 'undefined') {
            return;
        }
        window.sessionStorage.setItem('token', token);
        const spliteToken = token.split('.');
        /** token ingf **/
        //let tokenHeader = window.atob(spliteToken[0]);
        /** user, reseller info **/
        const tokenPayload = window.atob(spliteToken[1]);
        const jsonObject = JSON.parse(tokenPayload);

        window.sessionStorage.setItem(tokenInfo.PLATFORM_RESELLER_ID, jsonObject.platformResellerId);
        window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_ID, jsonObject.id);
        window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_LOGIN, jsonObject.username);
        window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_SESSION_EXPIRATION_TIME, jsonObject.exp);
        window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_SESSION_START_TIME, jsonObject.iat);
        window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_HAS_ACTIVE_SERIAL, jsonObject.hasActiveSerial || false);
        window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_IS_ROOT_RESELLER, jsonObject.isRootReseller || false);
        window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_CURRENCY_NAME, jsonObject.currencyName);
        window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_CURRENCY_SIGN, jsonObject.currencySign);
        window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_CURRENCY_SHORT, jsonObject.currencyShort);
        window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_USED_KERBEROS, jsonObject.kerberos || false);

        const platformType = jsonObject.platformType;
        if (platformType === tokenInfo.SYSTEM_TYPE_MVNO_PARTNER || platformType === tokenInfo.SYSTEM_TYPE_MVNO_PARTNER_EXPERT) {
            window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_PLATFORM_TYPE, tokenInfo.SYSTEM_TYPE_MVNO_ADMIN);
            window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_TYPE, tokenInfo.SYSTEM_TYPE_MVNO_PARTNER);
            if (platformType === tokenInfo.SYSTEM_TYPE_MVNO_PARTNER_EXPERT) {
                window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_EXPERT_MODE, 'EXPERT');
            } else {
                window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_EXPERT_MODE, 'NOEXPERT');
            }
        } else {
            if (platformType !== tokenInfo.SYSTEM_TYPE_MVNO_ADMIN_EXPERT) {
                window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_PLATFORM_TYPE, jsonObject.platformType);
                window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_TYPE, jsonObject.platformType);
                window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_EXPERT_MODE, 'NOEXPERT');
            } else {
                window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_PLATFORM_TYPE, tokenInfo.SYSTEM_TYPE_MVNO_ADMIN);
                window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_TYPE, tokenInfo.SYSTEM_TYPE_MVNO_ADMIN);
                window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_EXPERT_MODE, 'EXPERT');
            }
        }
        window.sessionStorage.setItem(tokenInfo.STORE_BROWSER_CARD_ID, token);
    },

    storeSystemAccess: (systemAccess: number): void => {
        window.sessionStorage.setItem(systemAccessType.SYSTEM_ACCESS_IDENTIFIER, systemAccess.toString());
    },

    storeRoles: (roles: Array<string>): void => {
        const tmpRoles = JSON.stringify(roles);
        window.sessionStorage.setItem(systemAccessType.ROLES_IDENTIFIER, tmpRoles);
    },

    storePasswordState: (state: { isSingleUse: boolean }): void => {
        const tmpState = JSON.stringify(state);
        window.sessionStorage.setItem(systemAccessType.PASSWORD_DATA_IDENTIFIER, tmpState);
    },

    storeCertificationState: (state: { allowGenericLogin: boolean }): void => {
        const tmpState = JSON.stringify(state);
        window.sessionStorage.setItem(systemAccessType.CERTIFICATION_DATA_IDENTIFIER, tmpState);
    },

    storeCustomerLevel: (customerLevel: number): void => {
        window.sessionStorage.setItem(tokenInfo.PLATFORM_USER_CUSTOMER_LEVEL, customerLevel.toString());
    },

    userHasActiveSerial: (): boolean => {
        const tmpState: string | null = window.sessionStorage.getItem(tokenInfo.PLATFORM_USER_HAS_ACTIVE_SERIAL);

        if (!tmpState || tmpState === 'false') {
            return false;
        }

        return true;
    },

    isRootReseller: (): boolean => {
        const tmpState: string | null = window.sessionStorage.getItem(tokenInfo.PLATFORM_USER_IS_ROOT_RESELLER);

        if (!tmpState || tmpState === 'false') {
            return false;
        }

        return true;
    },

    usedKerberos: (): boolean => {
        const tmpState: string | null = window.sessionStorage.getItem(tokenInfo.PLATFORM_USER_USED_KERBEROS);

        if (!tmpState || tmpState === 'false') {
            return false;
        }

        return true;
    },

    isGenericUser: (): boolean => {
        //DEBUG
        return true;
        //DEBUG

        // const tmpState: string | null = window.sessionStorage.getItem(systemAccessType.CERTIFICATION_DATA_IDENTIFIER);
        // if (!tmpState) {
        //     return false;
        // }
        //
        // const parsedState = JSON.parse(tmpState);
        // return parsedState.allowGenericLogin || false;
    },

    isDefinitelyGenericUser: (): boolean => {
        const tmpState: string | null = window.sessionStorage.getItem(systemAccessType.CERTIFICATION_DATA_IDENTIFIER);
        if (!tmpState) {
            return false;
        }

        const parsedState = JSON.parse(tmpState);
        return parsedState.allowGenericLogin || false;
    },

    singleUsePasswordPropagationEnded: (): boolean => {
        const tmpState: string | null = window.sessionStorage.getItem(systemAccessType.PASSWORD_DATA_IDENTIFIER);

        if (!tmpState) {
            return false;
        }

        return true;
    },

    usedSingleUsePassword: (): boolean => {
        const tmpState: string | null = window.sessionStorage.getItem(systemAccessType.PASSWORD_DATA_IDENTIFIER);
        if (!tmpState) {
            return false;
        }

        const parsedState = JSON.parse(tmpState);
        return parsedState.isSingleUse || false;
    },

    clearSingleUseState: (): void => {
        const tmpState: string | null = window.sessionStorage.getItem(systemAccessType.PASSWORD_DATA_IDENTIFIER);
        if (!tmpState) {
            return;
        }

        const parsedState = JSON.parse(tmpState);
        parsedState.isSingleUse = false;
        Auth.storePasswordState(parsedState);
    },

    getRoles: (): Array<string> => {
        const roles: string | null = window.sessionStorage.getItem(systemAccessType.ROLES_IDENTIFIER);

        if (!roles) {
            return [];
        }

        const parsedRoles = JSON.parse(roles);
        return parsedRoles || [];
    },

    getBearerAccessToken: (): string | null => {
        const accesstoken = Auth.getAccessToken();
        if (accesstoken) {
            return 'Bearer ' + accesstoken;
        }
        return null;
    },

    clearToken: (): void => {
        window.sessionStorage.clear();
    },

    isValidToken: (): string => {
        return Auth.getAccessToken();
    },

    getUserName: (): string => {
        return window.sessionStorage.getItem(tokenInfo.PLATFORM_USER_LOGIN) ?? '';
    },

    /**
     * timestamp
     * @returns integer|null
     */
    getSessionExpirationTime: (): number => {
        const item = window.sessionStorage.getItem(tokenInfo.PLATFORM_USER_SESSION_EXPIRATION_TIME);

        if (!item) {
            return 0;
        }
        return parseInt(item, 10);
    },

    getSessionStartTime: (): number => {
        return parseInt(window.sessionStorage.getItem(tokenInfo.PLATFORM_USER_SESSION_EXPIRATION_TIME) ?? '0');
    },

    getSessionValidTime: (): number => {
        const startTime = parseInt(window.sessionStorage.getItem(tokenInfo.PLATFORM_USER_SESSION_START_TIME) ?? '0');
        const stopTime = parseInt(window.sessionStorage.getItem(tokenInfo.PLATFORM_USER_SESSION_EXPIRATION_TIME) ?? '0');
        return stopTime - startTime;
    },

    getUserId: (): number => {
        const item = window.sessionStorage.getItem(tokenInfo.PLATFORM_USER_ID);

        if (!item) {
            return 0;
        }
        return parseInt(item, 10);
    },

    getUserPlatformResellerId: (): number => {
        const item = window.sessionStorage.getItem(tokenInfo.PLATFORM_RESELLER_ID);
        if (!item) {
            return 0;
        }
        return parseInt(item, 10);
    },

    setUserPlatformResellerName: (name: string): void => {
        window.sessionStorage.setItem(tokenInfo.PLATFORM_RESELLER_NAME, name);
    },

    getUserPlatformResellerName: (): string | null => {
        return window.sessionStorage.getItem(tokenInfo.PLATFORM_RESELLER_NAME);
    },

    getPlatformType: (): string => {
        return window.sessionStorage.getItem(tokenInfo.PLATFORM_USER_PLATFORM_TYPE) ?? '';
    },

    getUserType: (): string => {
        return window.sessionStorage.getItem(tokenInfo.PLATFORM_USER_TYPE) ?? '';
    },

    isExpertMode: (): boolean => {
        return window.sessionStorage.getItem(tokenInfo.PLATFORM_USER_EXPERT_MODE) === 'EXPERT';
    },

    isAdminExpertMode: (): boolean => {
        return Auth.isAdminMode() && Auth.isExpertMode();
    },

    isAdminMode: (): boolean => {
        const expertMode = window.sessionStorage.getItem(tokenInfo.PLATFORM_USER_TYPE);
        return expertMode === tokenInfo.SYSTEM_TYPE_MVNO_ADMIN;
    },

    isPartnerExpertMode: (): boolean => {
        return Auth.isPartnerMode && Auth.isExpertMode();
    },

    isPartnerMode: (): boolean => {
        const expertMode = window.sessionStorage.getItem(tokenInfo.PLATFORM_USER_TYPE);
        return expertMode === tokenInfo.SYSTEM_TYPE_MVNO_PARTNER;
    },

    isExpired: (): boolean => {
        const expirationTime = parseInt(window.sessionStorage.getItem(tokenInfo.PLATFORM_USER_SESSION_EXPIRATION_TIME) ?? '0');

        return expirationTime < DateHelperTs.getCurrentTimeStamp();
    },

    getCustomerLevel: (): number | null => {
        const level = window.sessionStorage.getItem(tokenInfo.PLATFORM_USER_CUSTOMER_LEVEL);
        if (level) {
            return parseInt(level);
        }
        return null;
    },

    hasSystemAccess: (system: number): boolean => {
        const storageSystemAccess = window.sessionStorage.getItem(systemAccessType.SYSTEM_ACCESS_IDENTIFIER);
        const systemAccess = storageSystemAccess ? parseInt(storageSystemAccess) : 0;

        if (!systemAccess || systemAccess === 0) {
            return false;
        }

        return (systemAccess & system) > 0;
    },

    getTranslationLang: (): string => {
        return localStorage.getItem('i18nextLng') ?? 'pl';
    },

    getCurrencyName: (): string|null => {
        const currencyName = window.sessionStorage.getItem(tokenInfo.PLATFORM_USER_CURRENCY_NAME) ?? '';
        return Buffer.from(currencyName, "base64").toString('utf8');
    },

    getCurrencySign: (): string|null => {
        const currencySign = window.sessionStorage.getItem(tokenInfo.PLATFORM_USER_CURRENCY_SIGN) ?? '';
        return Buffer.from(currencySign, "base64").toString('utf8');
    },

    getCurrencyShort: (): string|null => {
        const currencyShort = window.sessionStorage.getItem(tokenInfo.PLATFORM_USER_CURRENCY_SHORT) ?? '';
        return Buffer.from(currencyShort, "base64").toString('utf8');
    }
};
